import React, { useState, useRef, useEffect, Fragment, useCallback } from "react";
import Comment from "./Comment";
import { IoClose } from "react-icons/io5";
import { BsBookmarkCheckFill } from "react-icons/bs";
import { CiBookmarkPlus, CiSearch } from "react-icons/ci";
import { commentsData, neighborhoodNewsData } from "../../assets/data/Datas";
import { FaHeart, FaRegHeart, FaRegComment, FaRegShareSquare } from "react-icons/fa";
import { likePinboard, savePinboard, getAllPinboard, deletePinboard } from "../../redux/ApiSlice/Neighborhood/NeighborhoodPinboardSlice";
import { useDispatch, useSelector } from "react-redux";
import PinboardComment from "./PinboardComment";
import { createpinboardComment, createpinboardCommentReply, deletepinboardComment, deletepinboardCommentReply, getNeighborhoodPinboardComment, getNeighborhoodPinboardCommentReply, likeDislikePinboardCommentReply, likePinboardComment, updatepinboardComment, updatepinboardCommentReply } from "../../redux/ApiSlice/Neighborhood/NeighborhoodPinboardCommentSlice";
import { reportPinboardComment } from "../../redux/ApiSlice/Neighborhood/NeighborhoodPinboardReportSlice";
import { useNavigate } from "react-router-dom";
import { IoMdClose, IoIosArrowDown } from "react-icons/io";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { handleProfileNavigate } from "../../utils/handleProfileNavigate";
import toast from "react-hot-toast";

const PinboardPopup = ({ pinPost, onClose, onUpdate }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { User_profile } = useSelector((state) => state.AccountProfile);
    const { pinboardData } = useSelector((state) => state.NeighborhoodPinboard);
    const comments = useSelector((state) => state.NeighborhoodPinboardComment);

    const sharePopupRef = useRef(null);
    const commentPopupRef = useRef(null);
    const [searchInput, setSearchInput] = useState("");
    const [sharePopupOpen, setSharePopupOpen] = useState(false);
    const [commentPopupOpen, setCommentPopupOpen] = useState(false);
    const [postData, setPostData] = useState(null);
    const [loading, setLoading] = useState(false);



    const handleGetComments = useCallback(async () => {
        setLoading(true);
        try {
            dispatch(getNeighborhoodPinboardComment(pinPost.id));
            setLoading(false);

        } catch (error) {
            console.error("Error fetching comments:", error);
            setLoading(false);
        }
    }, [dispatch, pinPost.id]);


    useEffect(() => {
        handleGetComments();
    }, [handleGetComments])


    // Initialize local state with pinPost data when component mounts or pinPost changes
    useEffect(() => {
        if (pinPost) {
            // Try to get the latest version from Redux store
            const latestPost = pinboardData?.find(post => post.id === pinPost.id);
            setPostData(latestPost || pinPost);

            // If we found updated data, pass it back to parent
            if (latestPost && onUpdate) {
                onUpdate(latestPost);
            }
        }
    }, [pinPost, pinboardData, onUpdate]);

    const handleLikeToggle = async (id) => {
        try {
            const response = await dispatch(likePinboard(id));

            // Immediately update local state based on response
            if (response?.payload?.message === "Post liked successfully") {
                const updatedPost = {
                    ...postData,
                    likes_count: postData.likes_count + 1,
                    is_liked: true
                };
                // setPostData(updatedPost);
                if (onUpdate) onUpdate(updatedPost);
            } else if (response?.payload?.message === "Post unliked successfully") {
                const updatedPost = {
                    ...postData,
                    likes_count: postData.likes_count - 1,
                    is_liked: false
                };
                // setPostData(updatedPost);
                if (onUpdate) onUpdate(updatedPost);
            }

            // Force refresh of pinboard data after action to ensure consistency
            await dispatch(getAllPinboard());
        } catch (error) {
            console.error("Failed to like/unlike pinboard post:", error);
        }
    };

    const handleBookmarkToggle = async (id) => {
        try {
            const response = await dispatch(savePinboard(id));

            // Immediately update local state based on response
            if (response?.payload?.message === "Post saved successfully") {
                const updatedPost = {
                    ...postData,
                    is_saved: true
                };
                setPostData(updatedPost);
                if (onUpdate) onUpdate(updatedPost);
            } else if (response?.payload?.message === "Post unsaved successfully") {
                const updatedPost = {
                    ...postData,
                    is_saved: false
                };
                setPostData(updatedPost);
                if (onUpdate) onUpdate(updatedPost);
            }

            // Force refresh of pinboard data after action to ensure consistency
            await dispatch(getAllPinboard());
        } catch (error) {
            console.error("Failed to save/unsave pinboard post:", error);
        }
    };

    // Rest of your component remains unchanged
    const handleClickOutside = (event) => {
        if (sharePopupRef.current && !sharePopupRef.current.contains(event.target)) {
            setSharePopupOpen(false);
        }
        if (commentPopupRef.current && !commentPopupRef.current.contains(event.target)) {
            setCommentPopupOpen(false);
        }
        // Close user menu when clicking outside
        if (userMenuOpen && !event.target.closest('.user-menu-container')) {
            setUserMenuOpen(false);
        }
    };



    const handleNavigate = handleProfileNavigate(navigate, User_profile?.id);
    const menuRef = useRef(null);
    const dropdownRef = useRef(null);
    // const sharePopupRef = useRef(null);
    // const commentPopupRef = useRef(null);
    const replyPopupRef = useRef(null);

    const [pinboardDetails, setPinboardDetails] = useState(null);
    const [commentData, setCommentData] = useState([]);
    const [commentReplies, setCommentReplies] = useState([]);


    const [pinboardCommentText, setPinboardCommentText] = useState("");
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [filter, setFilter] = useState("Most Recent");
    const filters = ["Most Recent", "Top Comments"];
    const [activeMenuId, setActiveMenuId] = useState(null);
    const [isReportNews, setIsReportNews] = useState(false);
    // const [commentPopupOpen, setCommentPopupOpen] = useState(false);
    // const [sharePopupOpen, setSharePopupOpen] = useState(false);
    // const [searchInput, setSearchInput] = useState("");
    const [selectedCommentId, setSelectedCommentId] = useState(null);
    const [replyText, setReplyText] = useState("");
    const [openReplyPopup, setOpenReplyPopup] = useState(null);
    const [editReply, setEditReply] = useState(false);
    const [commentReport, setCommentReport] = useState(false);
    const [reportCommentText, setReportCommentText] = useState("");

    // User action menu states
    const [userMenuOpen, setUserMenuOpen] = useState(false);
    const [reportUser, setReportUser] = useState(false);
    const [showBlockConfirm, setShowBlockConfirm] = useState(false);
    const [showReasonDropdown, setShowReasonDropdown] = useState(false);
    const [reportReason, setReportReason] = useState("");
    const [reportMessage, setReportMessage] = useState("");
    const [reportLoading, setReportLoading] = useState(false);

    const handleMenuToggle = (id, event) => {
        event.stopPropagation();
        setActiveMenuId(activeMenuId === id ? null : id);
    };

    useEffect(() => {
        setCommentData(comments?.pinboardComment);
    }, [comments?.pinboardComment])


    useEffect(() => {
        setCommentReplies(comments?.pinboardCommentReply);
    }, [comments?.pinboardCommentReply])

    //comment section

    const handleCreatepinboardComment = async () => {
        if (!pinboardCommentText) {
            alert("Please enter a comment");
            return;
        }
        try {
            const response = await dispatch(createpinboardComment({ data: { post_comment_box: pinboardCommentText }, pinboardId: pinPost.id }));
            if (response) {
                setPinboardCommentText("");
                setCommentPopupOpen(false);
                setSelectedCommentId(null);
                setPostData((prevPost) => ({
                    ...prevPost,
                    comments_count: prevPost.comments_count + 1,
                }));
            }

        } catch (error) {
            console.error("Error creating comment:", error);
        }
    }

    const handleUpdatePinboardComment = async () => {
        if (!pinboardCommentText) {
            alert("Please enter a comment");
            return;
        }
        try {
            const response = await dispatch(updatepinboardComment({ data: { post_comment_box: pinboardCommentText }, commentId: selectedCommentId }));
        } catch (error) {

            console.error("Error updating comment:", error);
        }
        setCommentPopupOpen(false);
        setSelectedCommentId(null);
        setPinboardCommentText("");
    }

    const handleDeletePinboardComment = async (commentId) => {
        try {
            await dispatch(deletepinboardComment({ commentId }));
            setPostData((prevPost) => ({
                ...prevPost,
                comments_count: prevPost.comments_count - 1,
            }));

        } catch (error) {
            console.error("Error deleting pinboard:", error);
        }
        setActiveMenuId(null);
    }

    const handleLikepinboardComment = async (commentId) => {
        try {
            const response = await dispatch(likePinboardComment({ commentId }));
        } catch (error) {
            console.error("Error liking pinboard:", error);
        }
        setActiveMenuId(null);
    }

    ///reply comment section

    const getPinboardReplies = async (commentId) => {
        try {
            const response = await dispatch(getNeighborhoodPinboardCommentReply(commentId)).unwrap();
            if (response) {
                setCommentReplies(response);
            } else {
                console.error("Failed to fetch replies:", response.message);
            }
        } catch (error) {
            console.error("Error fetching replies:", error);
        }
    }


    const handleCreatePinboardReplyComment = async (commentId, reply) => {
        if (!reply) {
            alert("Please enter a comment");
            return;
        }
        try {
            const response = await dispatch(createpinboardCommentReply({ data: { post_comment_box: reply }, commentId }));
            if (response) {
                setReplyText("");
                setOpenReplyPopup(false);
                setSelectedCommentId(null);
                setCommentData((prevComments) =>
                    prevComments.map((comment) => {
                        if (comment.id === commentId) {
                            return {
                                ...comment,
                                reply_count: comment.reply_count + 1,
                            };
                        }
                        return comment;
                    })
                );
                getPinboardReplies(commentId);
            }
        } catch (error) {
            console.error("Error creating comment:", error);
        }
    }

    const editPinboardCommentReply = async (replyId, reply) => {
        if (!reply) {
            alert("Please enter a comment");
            return;
        }
        try {
            const response = await dispatch(updatepinboardCommentReply({ data: { post_comment_box: reply }, replyId }));
        } catch (error) {
            console.error("Error updating comment:", error);
        }
        setOpenReplyPopup(false);
        setReplyText("");
    }

    const handleDeletePinboardReplyComment = async (replyId, commentId) => {
        try {
            await dispatch(deletepinboardCommentReply({ replyId }));
            setCommentData((prevComments) =>
                prevComments.map((comment) => {
                    if (comment.id === commentId) {
                        return {
                            ...comment,
                            reply_count: comment.reply_count - 1,
                        };
                    }
                    return comment;
                })
            );

        } catch (error) {
            console.error("Error deleting pinboard:", error);
        }
        setActiveMenuId(null);
    }

    const handleEditPinboardComment = async (commentId, comment) => {
        setSelectedCommentId(commentId);
        setPinboardCommentText(comment?.post_comment_box);
        setCommentPopupOpen(true);
    }
    const handleEditPinboardCommentReply = async (reply, commentId) => {
        setSelectedCommentId(commentId)
        setEditReply(reply);
        setOpenReplyPopup(reply);
        setReplyText(reply.post_comment_box);
        // setOpenPopoverId(null); 
    }

    const handleLikeDislikePinboardCommentReply = async (replyId) => {
        try {
            const response = await dispatch(likeDislikePinboardCommentReply({ replyId }));
        } catch (error) {
            console.error("Error liking pinboard:", error);
        }
        setActiveMenuId(null);
    }

    const submitReportComment = async () => {
        const data = {
            reason: reportCommentText
        }
        if (
            !reportCommentText
        ) {
            return toast.error("Please enter a comment.");
        }
        try {
            const response = await dispatch(reportPinboardComment({ commentId: selectedCommentId, data })).unwrap();
            if (response) {
                setCommentReport(false);
                toast.success(response.message);
                setReportCommentText("");
                setSelectedCommentId(null);
                toast.success("Comment reported successfully.");

            } else {
                console.error("Failed to report comment:", response.message);
                toast.error("Failed to report comment.");
            }

        } catch (error) {
            toast.error("Already reported this comment.");
            setCommentReport(false);

        }
    }

    const handleReportComment = (comment) => {
        setSelectedCommentId(comment.id);
        setCommentReport(comment);
        setReportCommentText("");
    }

    // User menu handlers
    const handleUserMenuToggle = () => {
        setUserMenuOpen(!userMenuOpen);
    };

    const handleReportUser = () => {
        setReportUser(true);
        setUserMenuOpen(false);
    };

    const handleBlockUser = () => {
        setShowBlockConfirm(true);
        setUserMenuOpen(false);
    };

    const handleBlockConfirm = async () => {
        // TODO: Implement block user API call
        setShowBlockConfirm(false);
    };

    const handleBlockCancel = () => {
        setShowBlockConfirm(false);
    };

    const handleReasonSelect = (selectedReason) => {
        setReportReason(selectedReason);
        setShowReasonDropdown(false);
    };

    const handleSubmitReportUser = async () => {
        if (!reportReason) {
            alert("Please select a reason for reporting the user.");
            return;
        }

        setReportLoading(true);
        try {
            // TODO: Implement report user API call

            setReportUser(false);
            setReportLoading(false);
            setReportReason("");
            setReportMessage("");
            alert("User reported successfully.");
        } catch (error) {
            console.error("Error reporting user:", error);
            setReportLoading(false);
        }
    };
    const handleDeletePinboard = async (pinboardId) => {
        try {
            await dispatch(deletePinboard(pinboardId));
            onClose();
            toast.success("Pinboard deleted successfully.");
        } catch (error) {
            console.error("Error deleting pinboard:", error);
        }
        setActiveMenuId(null);
    }


    const reportReasons = [
        "Harassment",
        "Inappropriate",
        "Bullying or targeted harassment",
        "Hate speech",
        "Blackmail",
        "Sexual Harassment",
        "Impersonation/Fake account",
        "Graphic Violence/Gore",
        "Spam",
        "Drugs/Weapons",
        "Sexual content involving suspected minors",
        "Stalking or Intimidation",
        "Child safety concerns",
        "Self-harm or suicide content",
        "Violence or physical harm threats",
        "Dangerous acts & challenges",
        "Human exploitation/trafficking",
        "Scams/Fraud/Phishing",
        "Illegal Services/Solicitation",
        "IP Infringement",
        "Other"
    ];

    const handleFilterChange = (newFilter) => {
        setFilter(newFilter);
        setDropdownOpen(false);
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const filteredResults = neighborhoodNewsData.filter((data) =>
        data.firstName.toLowerCase().includes(searchInput.toLowerCase())
    );

    if (!postData) return null;

    return (
        <Fragment>
            <div className="absolute z-50 inset-0 h-full bg-black bg-opacity-70 flex items-center justify-center" onClick={onClose}>
                {/* Post data */}
                <div className="bg-white dark:bg-[#2d2b2b] dark:text-gray-300 rounded-lg relative h-[45vh] w-[95%] overflow-y-scroll z-30" onClick={(e) => e.stopPropagation()}>
                    <div className="px-3 pt-4">
                        <IoClose
                            onClick={onClose}
                            className="absolute top-3 right-2 text-[24px] cursor-pointer"
                        />
                        <div className="flex items-center mb-2">
                            <img
                                onClick={() => handleNavigate(postData.created_by.id)}
                                alt={postData.created_by.first_name}
                                src={postData.created_by.avatar_url}
                                className="w-10 h-10 object-cover rounded-full cursor-pointer"
                            />
                            <div className="flex flex-col ml-2 flex-1">
                                <div className="flex items-center gap-x-2">
                                    <p
                                        className="text-[12px] font-bold cursor-pointer"
                                        onClick={() => handleNavigate(postData.created_by.id)}
                                    >
                                        {postData.created_by.first_name} {postData.created_by.last_name}
                                    </p>
                                    <div className="relative user-menu-container">
                                        <HiOutlineDotsVertical
                                            onClick={handleUserMenuToggle}
                                            className="text-[15px] text-black dark:text-white cursor-pointer"
                                        />
                                        {userMenuOpen && (
                                            <>
                                                {User_profile?.id === postData.created_by.id ? (
                                                    <div className="absolute top-[22px] right-0 bg-white dark:bg-gray-900 border-2 border-indigo-100 z-10 rounded-lg whitespace-nowrap shadow-lg overflow-hidden">
                                                        <p
                                                            onClick={() => { navigate(`/neighborhood/pinboard/update/${postData?.id}`) }}
                                                            className="text-[12px] px-2 py-1 text-black dark:text-white hover:bg-gray-200 dark:hover:bg-gray-800 border-b border-gray-400 dark:border-gray-800 cursor-pointer"
                                                        >
                                                            Edit
                                                        </p>
                                                        <p
                                                            onClick={() => handleDeletePinboard(postData?.id)}
                                                            className="text-[12px] px-2 py-1 text-black dark:text-white hover:bg-gray-200 dark:hover:bg-gray-800 cursor-pointer"
                                                        >
                                                            Delete
                                                        </p>
                                                    </div>
                                                ) : (<div className="absolute top-[22px] right-0 bg-white dark:bg-gray-900 border-2 border-indigo-100 z-10 rounded-lg whitespace-nowrap shadow-lg overflow-hidden">
                                                    <p
                                                        onClick={handleBlockUser}
                                                        className="text-[12px] px-2 py-1 text-black dark:text-white hover:bg-gray-200 dark:hover:bg-gray-800 border-b border-gray-400 dark:border-gray-800 cursor-pointer"
                                                    >
                                                        Block
                                                    </p>
                                                    <p
                                                        onClick={handleReportUser}
                                                        className="text-[12px] px-2 py-1 text-black dark:text-white hover:bg-gray-200 dark:hover:bg-gray-800 cursor-pointer"
                                                    >
                                                        Report
                                                    </p>
                                                </div>)
                                                }
                                            </>
                                        )}
                                    </div>
                                </div>
                                <p className="text-[10px] text-gray-500">{postData.time_ago}</p>
                            </div>
                        </div>
                        <p className="text-[12px] font-bold">{postData.header}</p>
                        <p className="text-[10px] leading-[15px] my-1">{postData.description}</p>
                        <img
                            alt={postData.title}
                            src={postData.image}
                            className="w-full h-[160px] object-cover rounded-lg bg-gray-400"
                        />
                    </div>
                    <div className="flex items-center justify-between pb-1 pt-1 mx-3 border-b border-gray-400 dark:border-gray-800">
                        <div className="flex items-center gap-x-4 relative">
                            <div className="flex flex-col items-center">
                                {postData.is_liked ? (
                                    <FaHeart className="text-[16px] text-red-600 cursor-pointer" onClick={() => handleLikeToggle(postData.id)} />
                                ) : (
                                    <FaRegHeart className="text-[16px] text-gray-600 cursor-pointer" onClick={() => handleLikeToggle(postData.id)} />
                                )}
                                <p className="text-[8px] text-gray-500">{postData.likes_count}</p>
                            </div>
                            <div className="flex flex-col items-center">
                                <FaRegComment className="text-[16px] text-gray-600 dark:text-gray-300 cursor-pointer" onClick={() => setCommentPopupOpen(true)} />
                                <p className="text-[8px] text-gray-500">{postData.comments_count}</p>
                            </div>
                            {/* <div className="flex flex-col items-center" onClick={() => setSharePopupOpen(!sharePopupOpen)}>
                                <FaRegShareSquare className="text-[16px] text-gray-600 dark:text-gray-300 cursor-pointer" />
                                <p className="text-[8px] text-gray-500">{postData.shares_count}</p>
                            </div> */}
                            {sharePopupOpen && (
                                <div ref={sharePopupRef} className="absolute left-24 -top-10 p-1 w-[10rem] bg-white dark:bg-[#2b2b2b] border border-gray-400 overflow-hidden rounded shadow-lg">
                                    {/* Share popup content */}
                                    <div className="relative">
                                        <input
                                            type="text"
                                            placeholder="search"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            className="w-full h-6 pl-2 pr-6 py-[2px] border dark:bg-[#2b2b2b] border-gray-300 placeholder:text-[12px] text-[10px] rounded-lg focus:outline-none"
                                        />
                                        <CiSearch className="absolute right-1 top-1/2 transform -translate-y-1/2 transition-transform text-gray-500 hover:text-gray-700 text-[18px] cursor-pointer" />
                                    </div>
                                    <div className="flex items-center justify-between p-1">
                                        <div className="flex items-center gap-x-3 overflow-x-scroll">
                                            {filteredResults.length > 0 ? (
                                                filteredResults.map((data) => (
                                                    <div className="flex flex-col items-center cursor-pointer" key={data.id}>
                                                        <div className="h-6 w-6">
                                                            <img
                                                                alt={data.firstName}
                                                                src={data.profileImage}
                                                                className="w-6 h-6 object-cover rounded-full"
                                                            />
                                                        </div>
                                                        <p className="text-[8px]">{data.firstName}</p>
                                                    </div>
                                                ))
                                            ) : (
                                                <p className="text-[8px] text-gray-500">No results found</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        {postData.is_saved ? (
                            <BsBookmarkCheckFill className="text-[18px] text-gray-600 dark:text-blue-700 mr-[-2px] mt-[-5px] cursor-pointer" onClick={() => handleBookmarkToggle(postData.id)} />
                        ) : (
                            <CiBookmarkPlus className="text-[22px] text-gray-600 mr-[-5px] mt-[-5px] cursor-pointer" onClick={() => handleBookmarkToggle(postData.id)} />
                        )}
                    </div>

                    {/* Comment section */}
                    <div className="px-1 overflow-y-scroll h-[30vh]" >
                        <PinboardComment
                            comments={commentData}
                            replies={commentReplies}
                            loading={loading}
                            reportComment={handleReportComment}
                            replyLoading={comments.replyLoading}
                            setOpenReplyPopup={setOpenReplyPopup}
                            getPinboardReplies={getPinboardReplies}
                            handleLikefn={handleLikepinboardComment}
                            deleteComment={handleDeletePinboardComment}
                            deleteReply={handleDeletePinboardReplyComment}
                            editCommentReply={handleEditPinboardCommentReply}
                            handleEditPinboardComment={handleEditPinboardComment}
                            handleReplyLikefn={handleLikeDislikePinboardCommentReply}
                        />
                    </div>
                </div>
            </div>

            {/* Comment input section popup */}
            {commentPopupOpen && (
                <div className="absolute inset-0 flex items-center justify-center h-full bg-black bg-opacity-60  z-50">
                    <div ref={commentPopupRef} className="bg-white dark:bg-[#2b2b2b] p-4 m-2 rounded shadow-lg w-80">
                        <div className="flex justify-between items-center mb-2">
                            <p className="text-[14px] font-bold">Add a Comment</p>
                            <IoClose
                                onClick={() => setCommentPopupOpen(false)}
                                className="text-[20px] text-gray-900 dark:text-white hover:text-red-700 cursor-pointer"
                            />
                        </div>
                        <textarea
                            value={pinboardCommentText}
                            onChange={(e) => setPinboardCommentText(e.target.value)}
                            maxLength={200}
                            rows={4}
                            placeholder="Write your comment..."
                            className="w-full p-2 border border-gray-400 dark:border-gray-800 dark:bg-[#2b2b2b] rounded resize-none focus:outline-none text-[12px]"
                        />
                        <button
                            onClick={selectedCommentId ? handleUpdatePinboardComment : handleCreatepinboardComment}
                            className="mt-2 bg-gray-900 hover:bg-black text-[12px] text-white px-4 py-1 rounded transition-colors duration-500">
                            {selectedCommentId ? "Update" : "Comment"}

                        </button>
                    </div>
                </div>
            )}

            {/* Reply popup */}
            {openReplyPopup && (
                <div className="absolute inset-0 flex items-center justify-center h-full bg-black bg-opacity-50 z-50">
                    <div ref={replyPopupRef} className="bg-white dark:bg-[#2b2b2b] p-4 m-2 rounded shadow-lg w-80">
                        <div className="flex justify-between items-center mb-2">
                            <div className="flex items-start">
                                <img
                                    alt="User"
                                    className="w-6 h-6 object-cover rounded-full"
                                    src={openReplyPopup.created_by.avatar_url}
                                />
                                <div className="ml-2">
                                    <p className="text-[11px] font-bold dark:text-gray-300">{openReplyPopup.created_by.first_name} {
                                        openReplyPopup.created_by.last_name}</p>
                                    {/* <p className="text-[8px] text-gray-500">{timeAgo(openReplyPopup.created_at)}</p> */}
                                </div>
                            </div>
                            <IoMdClose
                                onClick={() => {
                                    setOpenReplyPopup(null),
                                        setReplyText(""),
                                        setEditReply(false)
                                }}
                                className="text-[20px] text-gray-900 dark:text-gray-200 hover:text-red-700 cursor-pointer"
                            />
                        </div>
                        {!editReply && <p className="text-[10px] mb-2 dark:text-gray-400">{openReplyPopup.post_comment_box}</p>}
                        <textarea
                            rows={2}
                            value={replyText}
                            onChange={(e) => setReplyText(e.target.value)}
                            placeholder="Write your reply..."
                            className="w-full p-2 border border-gray-400 dark:border-gray-800 dark:bg-[#292828] dark:text-gray-200 rounded resize-none focus:outline-none text-[10px]"
                        />
                        <button
                            onClick={() => editReply ? editPinboardCommentReply(openReplyPopup.id, replyText) : handleCreatePinboardReplyComment(openReplyPopup.id, replyText)}
                            className="mt-2 bg-gray-900 hover:bg-black text-[12px] text-white px-4 py-1 rounded transition-colors duration-500">
                            {editReply ? "Update Reply" : "Reply"}
                        </button>
                    </div>
                </div>
            )}

            {/* Report comment popup */}
            {commentReport && (
                <div className="absolute h-[66.5vh] inset-0 flex items-center justify-center bg-black bg-opacity-50 z-20">
                    <div ref={commentPopupRef} className="bg-white dark:bg-[#2b2b2b] dark:border p-4 m-2 rounded shadow-lg w-80">
                        <div className="flex justify-between items-center mb-2">
                            <div className="flex items-start">
                                <img
                                    alt="User"
                                    className="w-6 h-6 object-cover rounded-full"
                                    src={commentReport?.created_by?.avatar_url}
                                />
                                <div className="ml-2">
                                    <p className="text-[11px] font-bold dark:text-gray-300">{commentReport?.created_by?.first_name} {
                                        commentReport?.created_by?.last_name}</p>
                                </div>
                            </div>
                            <IoMdClose
                                onClick={() => {
                                    setCommentReport(false),
                                        setReportCommentText(""),
                                        setSelectedCommentId(null)
                                }}
                                className="text-[20px] text-gray-900 dark:text-gray-200 hover:text-red-700 cursor-pointer"
                            />
                        </div>
                        {!editReply && <p className="text-[10px] mb-2 dark:text-gray-400">{commentReport?.post_comment_box}</p>}


                        <textarea
                            rows={4}
                            value={reportCommentText}
                            onChange={(e) => setReportCommentText(e.target.value)}
                            placeholder="Write your report..."
                            className="w-full p-2 border border-gray-400 dark:border-gray-800 dark:text-gray-200 dark:bg-[#2b2b2b] rounded resize-none focus:outline-none text-[12px]"
                        />
                        <button onClick={() => submitReportComment()} className="mt-2 bg-gray-900 hover:bg-black text-[12px] text-white px-4 py-1 rounded transition-colors duration-500">
                            Report
                        </button>
                    </div>
                </div>
            )}

            {/* Report User Modal */}
            {reportUser && (
                <div className="absolute h-[66.5vh] inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center">
                    <div className="bg-white h-auto py-2 dark:bg-gray-900 shadow-lg rounded-lg w-[300px] flex flex-col items-center justify-center">
                        <p className="text-[24px] font-bold text-black dark:text-white text-center">
                            Report {postData.created_by.first_name}
                        </p>
                        <p className="text-[12px] text-black mb-2 dark:text-white text-center">
                            Are you sure you want to report {postData.created_by.first_name} {postData.created_by.last_name}?
                        </p>
                        <div className="px-2 w-full">
                            <label htmlFor="report-reason" className="block text-[12px] mb-0.5 font-semibold text-black dark:text-white">
                                Reason <span className="text-red-500">*</span>
                            </label>
                            <div className="relative custom-dropdown">
                                <div
                                    onClick={() => setShowReasonDropdown(!showReasonDropdown)}
                                    className="w-full h-[35px] border border-gray-400 dark:border-gray-600 bg-white dark:bg-black rounded-lg p-1 text-[12px] focus:outline-none cursor-pointer flex items-center justify-between"
                                >
                                    <span className={reportReason ? "text-black dark:text-white" : "text-gray-500"}>
                                        {reportReason || "Select a reason"}
                                    </span>
                                    <IoIosArrowDown className="text-gray-500" />
                                </div>
                                {showReasonDropdown && (
                                    <div className="absolute top-[36px] left-0 w-full bg-white dark:bg-black border border-gray-400 dark:border-gray-600 rounded-lg shadow-lg z-10 max-h-[125px] overflow-y-auto">
                                        {reportReasons.map((reasonOption, index) => (
                                            <div
                                                key={index}
                                                onClick={() => handleReasonSelect(reasonOption)}
                                                className="px-2 py-1.5 text-[12px] text-black dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800 cursor-pointer border-b border-gray-200 dark:border-gray-700 last:border-b-0"
                                            >
                                                {reasonOption}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="px-2 w-full mt-2">
                            <label htmlFor="report-details" className="block text-[12px] mb-0.5 font-semibold text-black dark:text-white">
                                Optional Details
                            </label>
                            <textarea
                                rows={6}
                                value={reportMessage}
                                maxLength={200}
                                id="report-details"
                                placeholder="Type your report here..."
                                onChange={(e) => setReportMessage(e.target.value)}
                                className="w-full h-[50px] border border-gray-400 dark:border-gray-600 dark:bg-black rounded-lg p-1.5 text-[12px] focus:outline-none resize-none"
                            />
                        </div>

                        <div className="flex gap-2 my-2">
                            <button
                                onClick={() => setReportUser(false)}
                                className="bg-[#1b1b1b] dark:bg-gray-400 dark:text-black dark:hover:bg-gray-500 hover:bg-[#0f0f0f] text-white px-3 py-1 rounded text-[12px]"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleSubmitReportUser}
                                className="border border-gray-400 dark:border-gray-800 bg-red-900 hover:bg-red-600 text-white px-3 py-1 rounded text-[12px]"
                            >
                                {reportLoading ? "Reporting..." : "Report"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Block User Confirmation Popup */}
            {showBlockConfirm && (
                <div className="absolute h-[66.5vh] inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
                    <div className="bg-white h-auto py-4 dark:bg-gray-900 shadow-lg rounded-lg w-[300px] flex flex-col items-center justify-center">
                        <p className="text-[24px] font-bold text-black dark:text-white text-center mb-2">
                            Block {postData.created_by.first_name}?
                        </p>
                        <p className="text-[12px] text-black px-4 dark:text-white text-center">
                            Are you sure you want to block {postData.created_by.first_name} {postData.created_by.last_name}? They will not be able to send you messages,
                            find your profile, or see your posts and they will not be notified that you blocked them.
                        </p>
                        <div className="flex gap-2 mt-4">
                            <button
                                onClick={handleBlockCancel}
                                className="bg-[#1b1b1b] dark:bg-gray-400 dark:text-black dark:hover:bg-gray-500 hover:bg-[#0f0f0f] text-white px-3 py-1 rounded text-[12px]"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleBlockConfirm}
                                className="bg-red-900 hover:bg-red-600 text-white px-3 py-1 rounded text-[12px]"
                            >
                                Block
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default PinboardPopup;